import React from 'react';
import { ArrowRight } from 'lucide-react';

export default function PopularIntegrations() {
    const integrations = [
        {
            name: 'WhatsApp',
            icon: (
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414-.074-.124-.272-.198-.57-.347z" fill="#25D366"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.477 2 2 6.477 2 12c0 2.159.685 4.158 1.854 5.793L2.5 21.5l3.827-1.325C7.901 21.282 9.878 22 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18c-1.89 0-3.642-.58-5.093-1.572l-.365-.248-2.274.787.798-2.213-.272-.383C3.738 15.006 3.143 13.56 3.143 12c0-4.883 3.974-8.857 8.857-8.857s8.857 3.974 8.857 8.857S16.883 20 12 20z" fill="#25D366"/>
                </svg>
            )
        },
        {
            name: 'Microsoft 365',
            icon: (
                <svg className="w-4 h-4" viewBox="0 0 24 24">
                    <path fill="#F25022" d="M1 1h10v10H1z"/>
                    <path fill="#7FBA00" d="M13 1h10v10H13z"/>
                    <path fill="#00A4EF" d="M1 13h10v10H1z"/>
                    <path fill="#FFB900" d="M13 13h10v10H13z"/>
                </svg>
            )
        },
        {
            name: 'Google Workspace',
            icon: (
                <svg className="w-4 h-4" viewBox="0 0 24 24">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z"/>
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"/>
                </svg>
            )
        },
        {
            name: 'Slack',
            icon: (
                <svg className="w-4 h-4" viewBox="0 0 24 24">
                    <path fill="#E01E5A" d="M6 15a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0 2.5a2.5 2.5 0 0 1 5 0v2.5a2.5 2.5 0 0 1-5 0v-2.5z"/>
                    <path fill="#36C5F0" d="M9 6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0zm-2.5 0a2.5 2.5 0 0 1 0 5H4a2.5 2.5 0 0 1 0-5h2.5z"/>
                    <path fill="#2EB67D" d="M18 9a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zm0-2.5a2.5 2.5 0 0 1-5 0V4a2.5 2.5 0 0 1 5 0v2.5z"/>
                    <path fill="#ECB22E" d="M15 18a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zm2.5 0a2.5 2.5 0 0 1 0-5H20a2.5 2.5 0 0 1 0 5h-2.5z"/>
                </svg>
            )
        },
        {
            name: 'HubSpot',
            icon: (
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="#FF7A59">
                    <path d="M18.1 8.2V5.5c.8-.4 1.4-1.3 1.4-2.3 0-1.4-1.1-2.5-2.5-2.5S14.5 1.8 14.5 3.2c0 1 .6 1.8 1.4 2.3v2.7c-1.3.4-2.4 1.2-3.1 2.3l-2.8-2.2c.1-.3.2-.6.2-1 0-1.4-1.1-2.5-2.5-2.5S5.2 5.9 5.2 7.3s1.1 2.5 2.5 2.5c.4 0 .7-.1 1-.2l2.7 2.1c-.8 1.1-1.2 2.5-1.2 4 0 .8.1 1.6.4 2.3l-2.1 1.3c-.3-.3-.8-.5-1.3-.5-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2c0-.2 0-.4-.1-.6l2.1-1.3c1.2 1.5 3.1 2.5 5.2 2.5 3.7 0 6.7-3 6.7-6.7 0-3.3-2.4-6.1-5.6-6.6zM17 19c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"/>
                </svg>
            )
        },
        {
            name: 'Salesforce',
            icon: (
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="#00A1E0">
                    <path d="M19.3 8.3c-.5-2.3-2.5-4-4.9-4-1.3 0-2.4.5-3.3 1.3C10.3 4.6 8.8 4 7.2 4 4.3 4 2 6.3 2 9.2c0 .4.1.8.2 1.2C.9 11.2 0 12.7 0 14.3 0 16.9 2.1 19 4.7 19h14.5c2.6 0 4.8-2.1 4.8-4.7 0-2.3-1.7-4.2-4.7-4.6-.2-.5-.2-1-.2-1.4z"/>
                </svg>
            )
        },
        {
            name: 'Zapier',
            icon: (
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="#FF4A00">
                    <path d="M13.5 0H10.5V8.5H13.5V0ZM24 10.5H15.5V13.5H24V10.5ZM13.5 15.5H10.5V24H13.5V15.5ZM8.5 10.5H0V13.5H8.5V10.5Z"/>
                </svg>
            )
        }
    ];

    return (
        <div className="bg-white rounded-2xl p-4 lg:px-6 border border-slate-200/70 shadow-sm flex flex-wrap lg:flex-nowrap items-center justify-between gap-4">
            <span className="text-xs font-extrabold text-slate-900 shrink-0">
                Intégrations populaires
            </span>

            <div className="flex flex-wrap items-center gap-3">
                {integrations.map((item, idx) => (
                    <div
                        key={idx}
                        className="flex items-center gap-2 px-3 py-1.5 rounded-xl bg-slate-50 border border-slate-200/60 text-slate-700 text-[11px] font-semibold"
                    >
                        {item.icon}
                        <span>{item.name}</span>
                    </div>
                ))}
            </div>

            <a
                href="/integrations"
                className="inline-flex items-center gap-1.5 text-xs font-bold text-blue-600 hover:text-blue-700 shrink-0"
            >
                <span>Voir toutes les intégrations</span>
                <ArrowRight size={13} />
            </a>
        </div>
    );
}